import { useState } from "react";
import PageHeading from "../../PageHeading";
import HospitalAgentList from "./HospitalAgent/HospitalAgentList";
import HospitalServiceList from "./HospitalServiceList/HospitalServiceList";
import HospitalBedAllocation from "./HospitalBed/HospitalBedAllocation";

const HospitalConfig = () => {
  const [activeTab, setActiveTab] = useState("Agent");

  const tabs = [
    {
      name: "Agent",
      content: (
        <div className="tab-content">
          <HospitalAgentList/>
        </div>
      ),
    },
    {
      name: "Service List",
      content: (
        <div className="tab-content">
          <HospitalServiceList/>
        </div>
      ),
    },
    {
      name: "Bed Allocation",
      content: (
        <div className="tab-content">
          <HospitalBedAllocation/>
        </div>
      ),
    },
  ];

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Hospital Office"},
    { label: "Hospital Office Config" },
  ];

  return (
    <div>
      <div className="print-hidden">
        <PageHeading title="Hospital Office Configuration" breadcrumbs={breadcrumbs} />
      </div>
      <div className="hospital-container flex flex-col xl:flex-row gap-5 items-start">
        {/* Left-side tabs */}
        <div className="tab-list flex w-full flex-col sm:flex-row xl:flex-col xl:w-64 shrink-0 bg-white border-r border-gray-200 shadow-sm rounded-lg overflow-hidden">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button w-full text-center xl:text-left py-3 px-2 xl:px-4 text-xs xl:text-sm font-medium text-gray-700 border-b border-gray-200 transition-colors duration-200 ${
                activeTab === tab.name
                  ? "bg-gray-100 text-blue-600 font-semibold"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-area flex-grow w-full">
          {tabs.find((tab) => tab.name === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};

export default HospitalConfig;